import script from "./LimitsExplained.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitsExplained.vue?vue&type=script&setup=true&lang=js"

import "./LimitsExplained.vue?vue&type=style&index=0&id=64cfd202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64cfd202"]])

export default __exports__